// constants
import { RequestsActionTypes } from "./constants";

//Action
export interface RequestsActionType {
  type:
  | RequestsActionTypes.GET_LIST_REQUESTS_ERROR
  | RequestsActionTypes.GET_LIST_REQUESTS_SUCCESS
  | RequestsActionTypes.GET_LIST_REQUESTS
  | RequestsActionTypes.CREATE_REQUEST
  | RequestsActionTypes.CREATE_REQUEST_SUCCESS
  | RequestsActionTypes.CREATE_REQUEST_ERROR
  | RequestsActionTypes.GET_REQUEST
  | RequestsActionTypes.GET_REQUEST_SUCCESS
  | RequestsActionTypes.GET_REQUEST_ERROR
  | RequestsActionTypes.UPDATE_REQUEST
  | RequestsActionTypes.UPDATE_REQUEST_SUCCESS
  | RequestsActionTypes.UPDATE_REQUEST_ERROR
  | RequestsActionTypes.UPDATE_STATUS_REQUEST
  | RequestsActionTypes.UPDATE_STATUS_REQUEST_SUCCESS
  | RequestsActionTypes.UPDATE_STATUS_REQUEST_ERROR
  | RequestsActionTypes.DELETE_REQUEST
  | RequestsActionTypes.DELETE_REQUEST_SUCCESS
  | RequestsActionTypes.DELETE_REQUEST_ERROR
  | RequestsActionTypes.ASSIGN_AGENTS
  | RequestsActionTypes.ASSIGN_AGENTS_SUCCESS
  | RequestsActionTypes.ASSIGN_AGENTS_ERROR
  | RequestsActionTypes.SUBMIT_QUOTE
  | RequestsActionTypes.SUBMIT_QUOTE_SUCCESS
  | RequestsActionTypes.SUBMIT_QUOTE_ERROR
  | RequestsActionTypes.APPROVE_QUOTE
  | RequestsActionTypes.APPROVE_QUOTE_SUCCESS
  | RequestsActionTypes.APPROVE_QUOTE_ERROR;
  payload: {} | string;
}

//Interfaces
interface RequestsData {
  iteam?: any[];
  total?: number;
  country?: string;
  keyword?: string;
  limit?: number;
  skip?: number;
  owner?: string;
}

interface RequestCreate {
  country: string;
  comment: string;
  description: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
  productLink: string;
}

interface RequestUpdate {
  comment: string;
  description: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
  productLink: string;
}

interface GetRequest {
  id: string;
}

interface DeleteRequest {
  ids: string[];
}

//Request_List
export const requestsGetListSuccess = (
  actionType: string,
  data: RequestsData | {}
): RequestsActionType => ({
  type: RequestsActionTypes.GET_LIST_REQUESTS_SUCCESS,
  payload: { actionType, data },
});

export const requestsGetListError = (
  actionType: string,
  error: string
): RequestsActionType => ({
  type: RequestsActionTypes.GET_LIST_REQUESTS_ERROR,
  payload: { actionType, error },
});

export const getRequestsList = (
  keyword: string = "",
  limit: number = 10,
  skip: number = 0,
  owner: string = "",
  country: string = "ic",
  startDate?: string,
  endDate?: string,
  status?: string,
  sourcingStatus?: string
): RequestsActionType => ({
  type: RequestsActionTypes.GET_LIST_REQUESTS,
  payload: { keyword, limit, skip, owner, country, status, sourcingStatus, startDate, endDate },
});

//Create Request
export const createRequestSuccess = (
  actionType: string,
  data: RequestCreate | {}
): RequestsActionType => ({
  type: RequestsActionTypes.CREATE_REQUEST_SUCCESS,
  payload: { actionType, data },
});
export const createRequestError = (
  actionType: string,
  error: string
): RequestsActionType => ({
  type: RequestsActionTypes.CREATE_REQUEST_ERROR,
  payload: { actionType, error },
});
export const createRequest = (
  country: string,
  comment: string,
  description: string,
  name: string,
  price: number,
  productImage: string,
  quantity: number,
  productLink: string
): RequestsActionType => ({
  type: RequestsActionTypes.CREATE_REQUEST,
  payload: {
    country,
    comment,
    description,
    name,
    price,
    productImage,
    quantity,
    productLink,
  },
});

//Update Status Request
export const updateStatusRequestSuccess = (
  actionType: string,
  data: RequestUpdate | {}
): RequestsActionType => ({
  type: RequestsActionTypes.UPDATE_STATUS_REQUEST_SUCCESS,
  payload: { actionType, data },
});
export const updateStatusRequestError = (
  actionType: string,
  error: string
): RequestsActionType => ({
  type: RequestsActionTypes.UPDATE_STATUS_REQUEST_ERROR,
  payload: { actionType, error },
});

export const updateStatusRequest = (id: string): RequestsActionType => ({
  type: RequestsActionTypes.UPDATE_STATUS_REQUEST,
  payload: { id },
});

//Update Request
export const updateRequestSuccess = (
  actionType: string,
  data: RequestUpdate | {}
): RequestsActionType => ({
  type: RequestsActionTypes.UPDATE_REQUEST_SUCCESS,
  payload: { actionType, data },
});
export const updateRequestError = (
  actionType: string,
  error: string
): RequestsActionType => ({
  type: RequestsActionTypes.UPDATE_REQUEST_ERROR,
  payload: { actionType, error },
});

export const updateRequest = (
  id: string,
  data: RequestUpdate
): RequestsActionType => ({
  type: RequestsActionTypes.UPDATE_REQUEST,
  payload: { id, ...data },
});

//GET Request

export const getRequestSuccess = (
  actionType: string,
  data: GetRequest | {}
): RequestsActionType => ({
  type: RequestsActionTypes.GET_REQUEST_SUCCESS,
  payload: { actionType, data },
});
export const getRequestError = (
  actionType: string,
  error: string
): RequestsActionType => ({
  type: RequestsActionTypes.GET_REQUEST_ERROR,
  payload: { actionType, error },
});

export const getRequest = (id: string): RequestsActionType => ({
  type: RequestsActionTypes.GET_REQUEST,
  payload: { id },
});

//DELETE Request

export const deleteRequestSuccess = (
  actionType: string,
  data: DeleteRequest | {}
): RequestsActionType => ({
  type: RequestsActionTypes.DELETE_REQUEST_SUCCESS,
  payload: { actionType, data },
});
export const deleteRequestError = (
  actionType: string,
  error: string
): RequestsActionType => ({
  type: RequestsActionTypes.DELETE_REQUEST_ERROR,
  payload: { actionType, error },
});

export const deleteRequest = (ids: string[]): RequestsActionType => ({
  type: RequestsActionTypes.DELETE_REQUEST,
  payload: { ids },
});

// Assign Agents
export const assignAgentsSuccess = (actionType: string, data: any): RequestsActionType => ({
  type: RequestsActionTypes.ASSIGN_AGENTS_SUCCESS,
  payload: { actionType, data },
});
export const assignAgentsError = (actionType: string, error: string): RequestsActionType => ({
  type: RequestsActionTypes.ASSIGN_AGENTS_ERROR,
  payload: { actionType, error },
});
export const assignAgents = (id: string, agentIds: string[]): RequestsActionType => ({
  type: RequestsActionTypes.ASSIGN_AGENTS,
  payload: { id, agentIds },
});

// Submit Quote
export const submitQuoteSuccess = (actionType: string, data: any): RequestsActionType => ({
  type: RequestsActionTypes.SUBMIT_QUOTE_SUCCESS,
  payload: { actionType, data },
});
export const submitQuoteError = (actionType: string, error: string): RequestsActionType => ({
  type: RequestsActionTypes.SUBMIT_QUOTE_ERROR,
  payload: { actionType, error },
});
export const submitQuote = (
  id: string,
  data: { quotedPricePerUnit: number; quotedQuantity: number; deliveryDelay: number; shippingCost?: number; quoteNotes?: string }
): RequestsActionType => ({
  type: RequestsActionTypes.SUBMIT_QUOTE,
  payload: { id, ...data },
});

// Approve/Reject Quote
export const approveQuoteSuccess = (actionType: string, data: any): RequestsActionType => ({
  type: RequestsActionTypes.APPROVE_QUOTE_SUCCESS,
  payload: { actionType, data },
});
export const approveQuoteError = (actionType: string, error: string): RequestsActionType => ({
  type: RequestsActionTypes.APPROVE_QUOTE_ERROR,
  payload: { actionType, error },
});
export const approveQuote = (id: string, approved: boolean, rejectionReason?: string): RequestsActionType => ({
  type: RequestsActionTypes.APPROVE_QUOTE,
  payload: { id, approved, rejectionReason },
});
